(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1660],{

/***/ 37260:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/colophon-standard",
      function () {
        return __webpack_require__(95209);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BaseSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59370);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52375);



var trimTrailingSlash = function(slug) {
    return slug[slug.length - 1] === "/" ? slug.slice(0, slug.length - 1) : slug;
};
var BaseSeo = function(param) {
    var title = param.title, ogTitle = param.ogTitle, description = param.description, ogDescription = param.ogDescription, path = param.path, image = param.image;
    var canonical = path ? "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(trimTrailingSlash(path)) : _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    var baseTitle = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_NAME */ .px;
    var baseDescription = "Colophon is an international, award-winning type foundry based in London (UK) and Los Angeles (US). We create, publish, and distribute high-quality retail and custom typefaces for analog and digital media.";
    var seoTitle = title || baseTitle;
    var seoDescription = description || baseDescription;
    var twitter = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1 ? {
        handle: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1,
        cardType: "summary_large_image"
    } : null;
    var openGraph = {
        url: canonical,
        title: ogTitle || seoTitle,
        description: ogDescription || seoDescription,
        images: [
            {
                url: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(image ? image : "/img/og.png"),
                alt: "Colophon Foundry"
            }
        ],
        site_name: "Colophon Foundry"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seoTitle,
        description: seoDescription,
        canonical: canonical,
        twitter: twitter,
        openGraph: openGraph
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseSeo);


/***/ }),

/***/ 95209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ colophon_standard; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./storyblok/index.ts + 2 modules
var storyblok = __webpack_require__(47659);
// EXTERNAL MODULE: ./components/index.ts + 27 modules
var components = __webpack_require__(94842);
// EXTERNAL MODULE: ./components/global/Footer/index.ts + 4 modules
var Footer = __webpack_require__(6695);
// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./components/global/Header/index.tsx + 7 modules
var Header = __webpack_require__(50794);
// EXTERNAL MODULE: ./components/seo/BaseSeo.tsx
var BaseSeo = __webpack_require__(57758);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.2_gtv7l6e4vdaiujlpfyxjguavla/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(42623);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Dropdown/index.tsx + 3 modules
var Dropdown = __webpack_require__(58677);
// EXTERNAL MODULE: ./components/global/PanelFont/PanelGlyphs/index.ts + 2 modules
var PanelGlyphs = __webpack_require__(10402);
// EXTERNAL MODULE: ./components/Spinner.tsx
var Spinner = __webpack_require__(90625);
// EXTERNAL MODULE: ./lib/productHelpers.tsx
var productHelpers = __webpack_require__(11603);
// EXTERNAL MODULE: ./lib/regions.ts
var regions = __webpack_require__(85567);
// EXTERNAL MODULE: ./lib/util.tsx + 1 modules
var util = __webpack_require__(70108);
// EXTERNAL MODULE: ./saleor/api.tsx + 4 modules
var api = __webpack_require__(67062);
// EXTERNAL MODULE: ./components/tools/ColophonStandard/ColophonStandard.module.scss
var ColophonStandard_module = __webpack_require__(99805);
var ColophonStandard_module_default = /*#__PURE__*/__webpack_require__.n(ColophonStandard_module);
;// CONCATENATED MODULE: ./components/tools/ColophonStandard/ColophonStandard.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var ColophonStandard = function(param1) {
    var title = param1.title, description = param1.description, _languages = param1.languages, languages = _languages === void 0 ? [] : _languages, products = param1.products, serverFontFamilyData = param1.serverFontFamilyData;
    var ref12;
    var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
    var ref1 = (0,react.useState)({}), fontStylesData = ref1[0], setFontStylesData = ref1[1];
    var ref2 = (0,react.useState)(null), fontFamily1 = ref2[0], setFontFamily = ref2[1];
    var ref3 = (0,react.useState)(null), fontStyles = ref3[0], setFontStyles = ref3[1];
    var ref4 = (0,react.useState)(null), fontStyleActive = ref4[0], setFontStyleActive = ref4[1];
    var ref5 = (0,react.useState)(null), fontStyleVersionActive = ref5[0], setFontStyleVersionActive = ref5[1];
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var fontStylesDataList = _objectSpread({}, serverFontFamilyData, fontStylesData);
    var selectedFontFamily = fontFamily1 || products[0];
    var fontStylesList = fontStyles || fontStylesDataList[selectedFontFamily.slug];
    var selectedFontStyle = fontStyleActive || (fontStylesList === null || fontStylesList === void 0 ? void 0 : fontStylesList[0]);
    var versionsList = selectedFontStyle === null || selectedFontStyle === void 0 ? void 0 : selectedFontStyle.versions;
    var selectedVersion = fontStyleVersionActive || (versionsList === null || versionsList === void 0 ? void 0 : versionsList.find(function(param) {
        var version = param.version;
        return version === "std";
    }));
    var fontStyleVersionScripts = (0,util/* getVersionScripts */.Bx)(selectedVersion);
    var ref7 = (0,react.useState)((fontStyleVersionScripts === null || fontStyleVersionScripts === void 0 ? void 0 : fontStyleVersionScripts[0]) || null), fontStyleVersionScriptActive = ref7[0], setFontStyleVersionScriptActive = ref7[1];
    // Computed variables
    var fontStyleVersionChars = fontStyleVersionScriptActive ? selectedVersion.fondue.categorisedCharacters.filter(function(char) {
        if (char.script) {
            return char.script === fontStyleVersionScriptActive;
        }
        // Default: Show glyphs with null script data when the script filter is Latin
        return char.script === null && fontStyleVersionScriptActive === "latin";
    }) : selectedVersion === null || selectedVersion === void 0 ? void 0 : (ref12 = selectedVersion.fondue) === null || ref12 === void 0 ? void 0 : ref12.categorisedCharacters;
    var fontSizeAdjust = (0,productHelpers/* getProductFontSizeAdjust */.tM)(selectedFontFamily);
    // Get font data here
    var getFontStylesData = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(fontFamily) {
            var ref, ref8, ref9, data, productRes, productFontFamily, variantFontStyles, awsS3fontDataPromises, ref10, ref11, awsS3FontData, awsS3fontDataFormatted, awsS3fontDataFormattedArray, versionActive;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        if (!(fontFamily && fontStylesDataList[fontFamily.slug])) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        data = fontStylesDataList[fontFamily.slug];
                        setFontStyles(data);
                        setFontStyleActive(data[0]);
                        setFontStyleVersionActive((ref = data[0].versions) === null || ref === void 0 ? void 0 : ref.find(function(param) {
                            var version = param.version;
                            return version === "std";
                        }));
                        setFontStyleVersionScriptActive((ref9 = (0,util/* getVersionScripts */.Bx)((ref8 = data[0].versions) === null || ref8 === void 0 ? void 0 : ref8.find(function(param) {
                            var version = param.version;
                            return version === "std";
                        }))) === null || ref9 === void 0 ? void 0 : ref9[0]);
                        setIsLoading(false);
                        return _ctx.abrupt("return");
                    case 10:
                        _ctx.next = 12;
                        return apolloClient.query({
                            query: api/* ProductByIdDocument */.MI8,
                            variables: {
                                id: fontFamily.id,
                                channel: "uk-store",
                                locale: (0,regions/* localeToEnum */.BN)(regions/* DEFAULT_LOCALE */.ZW)
                            }
                        });
                    case 12:
                        productRes = _ctx.sent;
                        productFontFamily = productRes.data.product;
                        variantFontStyles = productFontFamily.variants;
                        awsS3fontDataPromises = variantFontStyles.filter(function(fontStyle) {
                            return !(0,productHelpers/* isFamilyVariant */.S5)(fontStyle);
                        }).filter(function(fontStyle) {
                            return !(0,productHelpers/* isVariableFont */.bc)(fontStyle);
                        }).filter(function(fontStyle) {
                            return !fontStyle.sku.includes("-pro");
                        }).map(function(fontStyle) {
                            return (0,util/* generateAwsFontDataPromise */.Mw)(fontStyle);
                        });
                        _ctx.prev = 16;
                        ;
                        _ctx.next = 20;
                        return Promise.all(awsS3fontDataPromises);
                    case 20:
                        awsS3FontData = _ctx.sent;
                        awsS3fontDataFormatted = (0,util/* formatAwsS3FontData */.s$)(awsS3FontData);
                        awsS3fontDataFormattedArray = Object.values(awsS3fontDataFormatted);
                        versionActive = (ref10 = awsS3fontDataFormattedArray[0].versions) === null || ref10 === void 0 ? void 0 : ref10.find(function(param) {
                            var version = param.version;
                            return version === "std";
                        });
                        setFontStyles(awsS3fontDataFormattedArray);
                        setFontStyleActive(awsS3fontDataFormattedArray[0]);
                        setFontStyleVersionActive(versionActive);
                        setFontStyleVersionScriptActive((ref11 = (0,util/* getVersionScripts */.Bx)(versionActive)) === null || ref11 === void 0 ? void 0 : ref11[0]);
                        // Store data by font family slug key so can check if been fetched if requested again
                        setFontStylesData(_objectSpread({}, fontStylesData, _defineProperty({}, "".concat(fontFamily.slug), awsS3fontDataFormattedArray)));
                        setIsLoading(false);
                        _ctx.next = 35;
                        break;
                    case 32:
                        _ctx.prev = 32;
                        _ctx.t0 = _ctx["catch"](16);
                        setIsLoading(false);
                    case 35:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    16,
                    32
                ]
            ]);
        }));
        return function getFontStylesData(fontFamily) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnChangeFontFamily = function(e) {
        var fontFamilySelected = products.find(function(font) {
            return font.name === e.name;
        });
        setFontFamily(fontFamilySelected);
        setFontStyleVersionScriptActive(null);
        getFontStylesData(fontFamilySelected);
        return fontFamilySelected;
    };
    var handleOnChangeFontStyle = function(e) {
        var ref;
        var fontStyleSelected = fontStylesList.find(function(font) {
            return font.name === e.name;
        });
        setFontStyleActive(fontStyleSelected);
        setFontStyleVersionActive((ref = fontStyleSelected.versions) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var version = param.version;
            return version === "std";
        }));
        setFontStyleVersionScriptActive(fontStyleVersionScripts === null || fontStyleVersionScripts === void 0 ? void 0 : fontStyleVersionScripts[0]);
        return fontStyleSelected;
    };
    var handleOnChangeFontStyleVersionScript = function(script) {
        setFontStyleVersionScriptActive(script);
    };
    var handleOnChangeFontStyleVersionScriptDropdown = function(item) {
        setFontStyleVersionScriptActive(item.name);
        return item;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ColophonStandard_module_default()).ColophonStandard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ColophonStandard_module_default()).ColophonStandard__header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (0,clsx_m/* default */.Z)("u-h2", (ColophonStandard_module_default()).ColophonStandard__title),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)("u-h5", (ColophonStandard_module_default()).ColophonStandard__description),
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ColophonStandard_module_default()).ColophonStandard__content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelGlyphs/* PanelGlyphs */.g, _objectSpread({
                    fontSizeAdjust: fontSizeAdjust,
                    fontStyleVersionActive: selectedVersion,
                    fontStyleVersionChars: fontStyleVersionChars,
                    childrenHeader: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ColophonStandard_module_default()).ColophonStandard__panelHeaderLeft,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                        defaultValue: selectedFontFamily,
                                        items: products,
                                        onSelect: handleOnChangeFontFamily,
                                        color: "var(--color-primary)",
                                        inline: true,
                                        size: "small",
                                        fullWidth: true
                                    }),
                                    !isLoading && fontStylesList && fontStylesList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                        defaultValue: selectedFontStyle,
                                        items: fontStylesList,
                                        onSelect: handleOnChangeFontStyle,
                                        color: "var(--color-primary)",
                                        inline: true,
                                        size: "small",
                                        fullWidth: true
                                    }),
                                    !isLoading && !!fontStyleVersionScripts.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ColophonStandard_module_default()).ColophonStandard__ScriptsMobile,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                            onSelect: handleOnChangeFontStyleVersionScriptDropdown,
                                            defaultValue: fontStyleVersionScriptActive && {
                                                name: fontStyleVersionScriptActive
                                            },
                                            items: fontStyleVersionScripts.map(function(script) {
                                                return {
                                                    name: script
                                                };
                                            }),
                                            color: "var(--color-primary)",
                                            size: "small",
                                            fullWidth: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ColophonStandard_module_default()).ColophonStandard__panelHeaderRight,
                                children: !isLoading && fontStyleVersionScripts.map(function(script) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: (ColophonStandard_module_default()).ColophonStandard__scriptsButton,
                                        variant: "asLink",
                                        isActive: fontStyleVersionScriptActive === script,
                                        callBack: function() {
                                            handleOnChangeFontStyleVersionScript(script);
                                        },
                                        children: script
                                    }, script);
                                })
                            })
                        ]
                    })
                }, isLoading && {
                    childrenContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                        theme: "white",
                        relative: true
                    })
                }, {
                    childrenFooter: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ColophonStandard_module_default()).ColophonStandard__footer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (ColophonStandard_module_default()).languages,
                            children: languages.map(function(language) {
                                var str = language.split(" ");
                                var abbr = str === null || str === void 0 ? void 0 : str[0];
                                var lang = str.slice(1).join(" ");
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (ColophonStandard_module_default()).abbr,
                                            children: abbr
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: lang
                                        })
                                    ]
                                }, abbr);
                            })
                        })
                    })
                }))
            })
        ]
    });
};
/* harmony default export */ var ColophonStandard_ColophonStandard = (ColophonStandard);

// EXTERNAL MODULE: ./lib/storyblok/storyblokNavLinks.ts
var storyblokNavLinks = __webpack_require__(83176);
;// CONCATENATED MODULE: ./pages/tools/colophon-standard.tsx










var ColophonStandardPage = function(param) {
    var products = param.products, fontFamilyData = param.fontFamilyData, story = param.story, preview = param.preview, resolve_relations = param.resolve_relations;
    var content = story.content;
    var description = content.description, languages = content.languages;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var sbStory = preview ? (0,storyblok/* useStoryblok */.P)(story, preview, resolve_relations) : story;
    var globalLinks = (0,storyblokNavLinks/* getStoryBlokNavLinks */.G)(story);
    var _content = sbStory.content, _SEO = _content.SEO, SEO = _SEO === void 0 ? {} : _SEO, name = sbStory.name, full_slug = sbStory.full_slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSeo/* default */.Z, {
                title: SEO === null || SEO === void 0 ? void 0 : SEO.title,
                description: SEO === null || SEO === void 0 ? void 0 : SEO.description,
                ogDescription: SEO === null || SEO === void 0 ? void 0 : SEO.og_description,
                ogTitle: SEO === null || SEO === void 0 ? void 0 : SEO.og_title,
                image: SEO === null || SEO === void 0 ? void 0 : SEO.og_image,
                path: full_slug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                navigation: globalLinks,
                pageName: name,
                headerTheme: "header-white",
                hasBorder: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main",
                className: "page-theme-charcoal th-white-charcoal page-padding-top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                        sm: 12,
                        md: 12,
                        lg: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColophonStandard_ColophonStandard, {
                            title: name,
                            description: description,
                            languages: languages.split("\n"),
                            products: products,
                            serverFontFamilyData: fontFamilyData
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.ZP, {
                theme: "charcoal",
                navigation: globalLinks.footerLinks
            })
        ]
    });
};
ColophonStandardPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Layout */.Ar, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var colophon_standard = (ColophonStandardPage);


/***/ }),

/***/ 47659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Storyblok; },
  "P": function() { return /* reexport */ useStoryblok; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./storyblok/hooks/useStoryblok.ts


function useStoryblok(originalStory, preview) {
    var resolve_relations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var initEventListeners = // adds the events for updating the visual editor
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#initializing-the-storyblok-js-bridge
    function initEventListeners() {
        var StoryblokBridge = window.StoryblokBridge;
        if (typeof StoryblokBridge !== "undefined") {
            // initialize the bridge with your token
            var storyblokInstance = new StoryblokBridge({
                resolveRelations: resolve_relations
            });
            // reload on Next.js page on save or publish event in the Visual Editor
            storyblokInstance.on([
                "change",
                "published"
            ], function() {
                return location.reload();
            });
            // live update the story on input events
            storyblokInstance.on("input", function(event) {
                // check if the ids of the event and the passed story match
                if (story && event.story.content._uid === story.content._uid) {
                    // change the story content through the setStory function
                    setStory(event.story);
                }
            });
            storyblokInstance.on("enterEditmode", function(event) {
                // loading the draft version on initial enter of editor
                Storyblok.get("cdn/stories/".concat(event.storyId), {
                    resolve_relations: resolve_relations,
                    version: "draft"
                }).then(function(param) {
                    var data = param.data;
                    if (data.story) {
                        setStory(data.story);
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            });
        }
    };
    var addBridge = // appends the bridge script tag to our document
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#installing-the-storyblok-js-bridge
    function addBridge(callback) {
        // check if the script is already present
        var existingScript = document.getElementById("storyblokBridge");
        if (!existingScript) {
            var script = document.createElement("script");
            script.src = "//app.storyblok.com/f/storyblok-v2-latest.js";
            script.id = "storyblokBridge";
            document.body.appendChild(script);
            script.onload = function() {
                // once the scrip is loaded, init the event listeners
                callback();
            };
        } else {
            callback();
        }
    };
    var ref = (0,react.useState)(originalStory), story = ref[0], setStory = ref[1];
    (0,react.useEffect)(function() {
        // only load inside preview mode
        if (preview) {
            // first load the bridge, then initialize the event listeners
            addBridge(initEventListeners);
        }
    }, [
        originalStory,
        preview,
        setStory
    ]); // runs the effect only once & defines effect dependencies
    return story;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/storyblok-js-client@4.5.6_axios@0.21.4/node_modules/storyblok-js-client/dist/index.es.js
var index_es = __webpack_require__(78578);
;// CONCATENATED MODULE: ./storyblok/lib/storyblok.js

var STORYBOOK_API_KEY = "WygMRPInxMCOSMUw1Vt4TAtt";
var Storyblok = new index_es/* default */.Z({
    accessToken: STORYBOOK_API_KEY,
    cache: {
        clear: "auto",
        type: "memory"
    }
});

;// CONCATENATED MODULE: ./storyblok/index.ts




/***/ }),

/***/ 99805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ColophonStandard":"ColophonStandard_ColophonStandard__qVSEx","ColophonStandard__header":"ColophonStandard_ColophonStandard__header__kE2RS","ColophonStandard__title":"ColophonStandard_ColophonStandard__title__6R7h6","ColophonStandard__description":"ColophonStandard_ColophonStandard__description__g5TGr","ColophonStandard__panelHeaderLeft":"ColophonStandard_ColophonStandard__panelHeaderLeft__b4Wlh","ColophonStandard__panelHeaderRight":"ColophonStandard_ColophonStandard__panelHeaderRight__niHnP","ColophonStandard__scriptsButton":"ColophonStandard_ColophonStandard__scriptsButton__jP5DE","ColophonStandard__content":"ColophonStandard_ColophonStandard__content__05N9Y","ColophonStandard__ScriptsMobile":"ColophonStandard_ColophonStandard__ScriptsMobile__R1KOu","ColophonStandard__footer":"ColophonStandard_ColophonStandard__footer__BOZdC","languages":"ColophonStandard_languages__xlHX6","abbr":"ColophonStandard_abbr__seuWF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7099,9370,8578,7972,402,9774,2888,179], function() { return __webpack_exec__(37260); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);